import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-trial',
    templateUrl: './trial.component.html',
    styleUrls: ['./trial.component.scss'],
    standalone: false
})
export class TrialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
